export default __webpack_public_path__ + "static/media/logo.567d2c87.svg";